const DataProjects = [
    {
        url : "/projects/palm-beach",
        image : "/images/projects/brooks-listing.jpg",
        title : "Palm Beach"
    },
    {
        url : "/projects/balmain",
        image : "/images/projects/balmain-listing.jpg",
        title : "Balmain"
    },
    {
        url : "/projects/haberfield",
        image : "/images/projects/haberfield-listing.jpg",
        title : "Haberfield"
    },
    {
        url : "/projects/roselle",
        image : "/images/projects/roselle-listing.jpg",
        title : "Roselle"
    },
    {
        url : "/projects/bondi",
        image : "/images/projects/bondi-listing.jpg",
        title : "Bondi"
    },
    {
        url : "/projects/mosman",
        image : "/images/projects/mosman-listing.jpg",
        title : "Mosman"
    },
    {
        url : "/projects/earlwood",
        image : "/images/projects/earlwood-listing.jpg",
        title : "Earlwood"
    },
    {
        url : "/projects/darling-point",
        image : "/images/projects/darling-listing.jpg",
        title : "Darling Point"
    },
    {
        url : "/projects/cammeray",
        image : "/images/projects/cammeray-listing.jpg",
        title : "Cammeray"
    },
    {
        url : "/projects/castle-hill",
        image : "/images/projects/castle-hill-listing.jpg",
        title : "Castle Hill"
    },
    {
        url : "/projects/haberfield-2",
        image : "/images/projects/haberfield2-listing.jpg",
        title : "Haberfield Traditional"
    },
    {
        url : "/projects/balmoral",
        image : "/images/projects/haberfield-listing.jpg",
        title : "Balmoral"
    },
    {
        url : "/projects/strathfield",
        image : "/images/projects/haberfield-listing.jpg",
        title : "Strathfield"
    },
    {
        url : "/projects/lane-cove",
        image : "/images/projects/lane-cove-listing.jpg",
        title : "Lane Cove"
    },
    {
        url : "/projects/cheltenham",
        image : "/images/projects/cheltenham-listing.jpg",
        title : "Cheltenham"
    },
    {
        url : "/projects/paddington",
        image : "/images/projects/paddington-listing.jpg",
        title : "Paddington"
    }
]

export default DataProjects;